goog.provide("shadow.js.shim.module$src$svg$controls$filter_svg");
goog.provide("module$shadow_js_shim_module$src$svg$controls$filter_svg");
shadow.js.shim.module$src$svg$controls$filter_svg = shadow.js.nativeProvides["src/svg/controls/filter.svg"] = shadow$bridge("src/svg/controls/filter.svg");
module$shadow_js_shim_module$src$svg$controls$filter_svg.default = shadow.js.shim.module$src$svg$controls$filter_svg;
